module.exports = __webpack_public_path__ + "img/setting_btn.18812d16.png";